import {
  Component,
  OnInit,
  Directive,
  ElementRef,
  Input,
  HostListener, EventEmitter, Output, OnChanges
} from "@angular/core";
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { DomSanitizer } from "@angular/platform-browser";
import { DataService } from "../../services/data.service"
import { InProductsService } from "../../services/inventory/in-products.service";
import { AuthenticationService } from "../../services/authentication.service";
import { environment } from "../../../../environments/environment";
import { forEach } from "@angular/router/src/utils/collection";
import { InToolsService } from '../../../shared/services/inventory/in-tools.service';

export interface PriceItems {
  title: string;
  Items: any;

}

@Component({
  selector: 'app-sellingpricelevel-popup',
  templateUrl: './sellingpricelevel-popup.component.html',
  styleUrls: ['./sellingpricelevel-popup.component.css']
})
export class SellingPriceLevelPopUpComponent extends DialogComponent<PriceItems, boolean>
  implements PriceItems, OnInit, OnChanges {

  title: string;
  Items: any = [];
  result: any = { result: false, RtnItem: {} };
  @Input() popup: boolean = true;

  model = new SellingPriceLevel_Master();

  loading: boolean = false

  constructor(dialogService: DialogService, private sanitizer: DomSanitizer, private ds: DataService, private ts: InToolsService, private aut: AuthenticationService) {
    super(dialogService);
  }

  ngOnChanges() {

  }
  ngOnInit() {
    this.model = new SellingPriceLevel_Master();

  }

  validateItem(): boolean {
    if (this.model.Name == "") {
      alert("Please enter Name");
      return false;
    }
    return true;
  }

  saveItem() {
    if (this.validateItem()) {
      this.loading = true;
      this.model.UserId = this.ds.Settings.UserId;
      this.ts.Save_SellingPriceLevel(this.model).subscribe(res => {
        if (res.Success) {
          alert("Price Level Saved Successfully");
          this.result.result = true;
          this.clear();
          this.loading = false;
        }
        else {
          alert(res.error.UsrMsg);
          this.loading = false;
        }
      });

    }

  }

  clear() {
    this.model = new SellingPriceLevel_Master();
  }
  cancel() {
    this.model = new SellingPriceLevel_Master();
    this.close();
  }


}

class SellingPriceLevel_Master {
  Id: number = 0;
  Name: String = "";
  UserId: number = 0;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/sellingpricelevel-popup/sellingpricelevel-popup.component.ts